<template>
  <v-container fluid class="pa-0">
    <v-row align="center" class>
      <v-col cols="12" md="12" lg="12" sm="12" class="pa-0" style="color:white">
        <div class="ma-1">
          <div class="pa-5">
            <p class="google-font mb-0" style="font-size:150%">Über HolyCode</p>
            <p
              class="google-font mt-0"
              style="font-size:95%"
            >HolyCode beschreibt die liebe zur Programmierung und zum Coden. Diese Webseite dient als Sammelpunkt aller Ergebnisse.</p>
            
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data: () => ({}),
  computed: {
    ...mapState(["config"])
  }
};
</script>